const styles = {
  inputBox: {
    display: 'flex',
    flexDirection: 'column',
  },
  field: {
    mb: '20px',
  },
  helperText: {
    fontSize: '0.875rem',
    fontWeight: 400,
    textTransform: 'initial',
  },
};

export default styles;
